import { useSandpack } from "./useSandpack";
export var useSandpackNavigation = function useSandpackNavigation(clientId) {
  var _useSandpack = useSandpack(),
      dispatch = _useSandpack.dispatch;

  return {
    refresh: function refresh() {
      return dispatch({
        type: "refresh"
      }, clientId);
    },
    back: function back() {
      return dispatch({
        type: "urlback"
      }, clientId);
    },
    forward: function forward() {
      return dispatch({
        type: "urlforward"
      }, clientId);
    }
  };
};